import { Injectable } from "@angular/core";
import { ImageSEO } from "../models/image-seo.model";
import { SiilaTranslationService } from "./siila-translation.service";
import { environment } from "../../../environments/environment";

@Injectable()
export class StaticImagesSEOService {
  currentCode: string;

  private readonly advertiserMeta: Record<
    string,
    Record<number, { advertiserSlug: string; advertiserName: string }>
  > = {
    br: {
      1: { advertiserSlug: "Maxcorp", advertiserName: "Maxcorp" },
      2: { advertiserSlug: "t2", advertiserName: "T2" },
      3: { advertiserSlug: "cy_capital", advertiserName: "Cy.Capital" },
      4: { advertiserSlug: "zolver", advertiserName: "Zolver" },
      5: { advertiserSlug: "retha", advertiserName: "Retha" },
      6: { advertiserSlug: "barzel", advertiserName: "Barzel" },
      7: { advertiserSlug: "capright", advertiserName: "Capright" },
      8: { advertiserSlug: "siila", advertiserName: "SiiLA" }
      //7: { advertiserSlug: "unioncorp", advertiserName: "Unioncorp" },
      /* 7: { advertiserSlug: "siila_academy", advertiserName: "SiiLA Academy" } */
    },
    mx: {
      1: { advertiserSlug: "siila", advertiserName: "SiiLA" },
      2: { advertiserSlug: "capright", advertiserName: "Capright" },
      3: { advertiserSlug: "avalous", advertiserName: "Avalous" },
      4: { advertiserSlug: "siila", advertiserName: "SiiLA" },
      5: { advertiserSlug: "capright", advertiserName: "Capright" },
      6: { advertiserSlug: "avalous", advertiserName: "Avalous" }
    },
    latam: {
      1: { advertiserSlug: "siila", advertiserName: "SiiLA" },
      2: { advertiserSlug: "capright", advertiserName: "Capright" },
      3: { advertiserSlug: "siila", advertiserName: "SiiLA" },
      4: { advertiserSlug: "capright", advertiserName: "Capright" },
      5: { advertiserSlug: "siila", advertiserName: "SiiLA" },
      6: { advertiserSlug: "capright", advertiserName: "Capright" }
    }
  };

  constructor(private ts: SiilaTranslationService) {
    this.currentCode = environment.platformId;
  }

  getSiilaBrandSEOInfo(): ImageSEO {
    const titleKey = "siilabrand";
    const staticImg = "assets/img/SiiLA_SVG.svg";
    let result: ImageSEO = this.findTitleTranslation(titleKey, staticImg);
    return result;
  }

  getMarketAnalyticsRealIntelligenceSEO(): ImageSEO {
    const titleKey = "marketAnalyticsRealIntelligence";
    const staticImg = this.getImgBannerMarket();
    let result: ImageSEO = this.findTitleTranslation(titleKey, staticImg);
    return result;
  }

  getMultifamilySEO(): ImageSEO {
    const titleKey = "multifamilyText";
    const staticImg = this.getImgBannerMarket();
    let result: ImageSEO = this.findTitleTranslation(titleKey, staticImg);
    return result;
  }

  getAcademyImgSEO(): ImageSEO {
    const titleKey = "academyImg";
    const staticImg = this.getImgBannerAcademy();
    let result: ImageSEO = this.findTitleTranslation(titleKey, staticImg);
    return result;
  }

  getSpotTransformingExperienceSEO(): ImageSEO {
    const titleKey = "spotTransformingExperience";
    const staticImg = this.getSpotTransformingExperienceImg();
    let result: ImageSEO = this.findTitleTranslation(titleKey, staticImg);
    return result;
  }

  getCommercialestatenewslatam(): ImageSEO {
    const titleKey = "commercialestatenewslatam";
    const staticImg = this.imgNewMobile();
    let result: ImageSEO = this.findTitleTranslation(titleKey, staticImg);
    return result;
  }

  getLinkedinSEO(): ImageSEO {
    const titleKey = "socialmedia.linkedin";
    let result: ImageSEO = this.findTitleTranslation(titleKey);
    return result;
  }

  getTikTokSEO(): ImageSEO {
    const titleKey = "socialmedia.tiktok";
    let result: ImageSEO = this.findTitleTranslation(titleKey);
    return result;
  }

  getYoutubeSEO(): ImageSEO {
    const titleKey = "socialmedia.youtube";
    let result: ImageSEO = this.findTitleTranslation(titleKey);
    return result;
  }

  getFacebookSEO(): ImageSEO {
    const titleKey = "socialmedia.facebook";
    let result: ImageSEO = this.findTitleTranslation(titleKey);
    return result;
  }

  getInstagramSEO(): ImageSEO {
    const titleKey = "socialmedia.instagram";
    let result: ImageSEO = this.findTitleTranslation(titleKey);
    return result;
  }

  getTwitterSEO(): ImageSEO {
    const titleKey = "socialmedia.twitter";
    let result: ImageSEO = this.findTitleTranslation(titleKey);
    return result;
  }

  getShareWhatsappSEO(): ImageSEO {
    const titleKey = "sharesocial.whatsapp";
    let result: ImageSEO = this.findTitleTranslation(titleKey);
    return result;
  }

  getShareEmailSEO(): ImageSEO {
    const titleKey = "sharesocial.email";
    let result: ImageSEO = this.findTitleTranslation(titleKey);
    return result;
  }

  getShareFacebookSEO(): ImageSEO {
    const titleKey = "sharesocial.facebook";
    let result: ImageSEO = this.findTitleTranslation(titleKey);
    return result;
  }

  getShareLinkedinSEO(): ImageSEO {
    const titleKey = "sharesocial.linkedin";
    let result: ImageSEO = this.findTitleTranslation(titleKey);
    return result;
  }

  getSpotifySEO(): ImageSEO {
    const titleKey = "sharesocial.spotify";
    let result: ImageSEO = this.findTitleTranslation(titleKey);
    return result;
  }

  private getImgBannerMarket() {
    if (
      this.currentCode == "mx" ||
      this.currentCode == "latam" ||
      this.currentCode == "co"
    ) {
      return this.ts.getCurrentLanguage() == "en"
        ? "../../../../assets/img/Frame 574.jpg"
        : "../../../../assets/img/BANNER MA - RESOURCE.png";
    } else {
      return this.ts.getCurrentLanguage() == "en"
        ? "../../../../assets/img/Multifamily-Banner-EN.png"
        : "../../../../assets/img/Multifamily-Banner-PT.png";
    }
  }

  private getImgBannerAcademy() {
    if (
      this.currentCode == "mx" ||
      this.currentCode == "latam" ||
      this.currentCode == "co"
    ) {
      return this.ts.getCurrentLanguage() == "en"
        ? "../../../../assets/img/EN - BANNER ACADEMY ADVANCED 2024.png"
        : "../../../../assets/img/PT - BANNER ACADEMY ADVANCED 2024.png";
    } else {
      return this.ts.getCurrentLanguage() == "en"
        ? "../../../../assets/img/EN - BANNER ACADEMY ADVANCED 2024.png"
        : "../../../../assets/img/PT - BANNER ACADEMY ADVANCED 2024.png";
    }
  }

  private getSpotTransformingExperienceImg() {
    if (
      this.currentCode == "mx" ||
      this.currentCode == "latam" ||
      this.currentCode == "co"
    ) {
      return this.ts.getCurrentLanguage() == "en"
        ? "../../../../assets/img/MX EN VERSION.png"
        : "../../../../assets/img/SP VERSION.png";
    } else {
      return this.ts.getCurrentLanguage() == "en"
        ? "../../../../assets/img/Card.jpg"
        : "../../../../assets/img/PT VERSION.png";
    }
  }

  imgNewMobile() {
    let img = "../../../../assets/img/products-list/";
    if (this.currentCode == "mx" || this.currentCode == "co") {
      if (this.ts.getCurrentLanguage() == "en") {
        img = img + "IPHONE14_EN.png";
      } else {
        img = img + "IPHONE14_ES.png";
      }
    } else {
      if (this.ts.getCurrentLanguage() == "en") {
        img = img + "IPHONE14_EN.png";
      } else {
        img = img + "IPHONE14_PT.png";
      }
    }

    return img;
  }

  getTopLeaderboardBanner(): ImageSEO {
    const isEnglish = this.ts.getCurrentLanguage() == "en";
    const topBannerConfig = {
      img: isEnglish
        ? "assets/img/Banner Header_EN.gif"
        : "assets/img/Banner Header_PT.gif",
      link: isEnglish ? "https://cy.capital/en" : "https://cy.capital/pt-br",
      advertiserSlug: "cy_capital",
      advertiserName: "cy.capital"
    };

    let result: ImageSEO = {
      src: topBannerConfig.img,
      title: topBannerConfig.advertiserName,
      alt: topBannerConfig.advertiserName,
      link: topBannerConfig.link,
      type: "image",
      advertiserSlug: topBannerConfig.advertiserSlug,
      advertiserName: topBannerConfig.advertiserName
    };
    return result;
  }

  getBannerOdd(): ImageSEO {
    return this.getBannerByRotation("odd");
  }

  getBannerPairs(): ImageSEO {
    return this.getBannerByRotation("pair");
  }

  private getBannerByRotation(type: "odd" | "pair"): ImageSEO {
    const count = localStorage.getItem("bannerCount");
    const rotation = this.getRotationNumber(count, type);
    const imgPath = this.resolveImagePath(rotation);
    const title = this.resolveTitle(rotation);
    return this.setBannerTitle(title, imgPath);
  }

  private resolveTitle(rotation: number): string {
    return this.ts.getTranslationFromJSONFiles(
      `imgSEO.imgBanner.${rotation}.title`
    );
  }

  private getRotationNumber(
    count: string | null,
    type: "odd" | "pair"
  ): number {
    const totalBanners = this.getTotalBanners();
    const parsedCount = Number(count);
    const safeCount = !isNaN(parsedCount) && parsedCount > 0 ? parsedCount : 1;
    let topIndex: number;
    if (totalBanners % 2 === 0) {
      const pairsPerView = totalBanners / 2;
      const totalStates = totalBanners * pairsPerView;
      const zeroBased = (safeCount - 1) % totalStates;
      const positionInView = zeroBased % pairsPerView;
      const rotationShift = Math.floor(zeroBased / pairsPerView) % totalBanners;
      topIndex = (positionInView * 2 + rotationShift) % totalBanners;
    } else {
      const totalStates = totalBanners * totalBanners;
      const zeroBased = (safeCount - 1) % totalStates;
      const roundNumber = Math.floor(zeroBased / totalBanners);
      const posInRound = zeroBased % totalBanners;
      topIndex = ((posInRound + roundNumber) * 2) % totalBanners;
    }
    const bottomIndex = (topIndex + 1) % totalBanners;
    const resolvedIndex = type === "odd" ? topIndex : bottomIndex;
    return resolvedIndex + 1;
  }

  private getTotalBanners(): number {
    return this.currentCode === "br" ? 8 : 6;
  }

  private resolveImagePath(rotation: number) {
    const img = "../../../../assets/img/";
    const lang = this.ts.getCurrentLanguage();
    const code = this.currentCode;

    const banners = {
      br: {
        1: {
          type: "image",
          en: "Banner institucional_Maxcorp_EN.gif",
          pt: "Banner institucional_Maxcorp.gif",
          link: {
            en: "https://www.maxcorpimoveis.com.br/",
            pt: "https://www.maxcorpimoveis.com.br/"
          }
        },
        2: {
          type: "image",
          en: "Banner REsource_v3.3 EN.gif",
          pt: "Banner REsource_v3.3 PT.gif",
          link: {
            en: "https://www.t2arquitetura.com.br/",
            pt: "https://www.t2arquitetura.com.br/"
          }
        },
        3: {
          type: "image",
          en: "Banner cy.capital v4.2_EN.gif",
          pt: "Banner cy.capital v4.2_PT.gif",
          link: {
            en: "https://cy.capital/en",
            pt: "https://cy.capital/pt-br"
          }
        },
        4: {
          type: "image",
          en: "Banner_Junho_zolver.gif",
          pt: "Banner_Junho_zolver.gif",
          link: {
            en: "https://bit.ly/SiiLAZolverBREN",
            pt: "https://bit.ly/SiiLAZolverBRPT"
          }
        },
        5: {
          type: "image",
          en: "Banner EN_Junho_retha.gif",
          pt: "Banner PT_Junho_retha.gif",
          link: "https://bit.ly/SiiLARethaBR"
        },
        6: {
          type: "image",
          en: "Banner EN_Junho_barzel.gif",
          pt: "Banner PT_Junho_barzel.gif",
          link: {
            en: "https://bit.ly/SiiLABarzelBREN",
            pt: "https://bit.ly/SiiLABarzelBRPT"
          }
        },
        7: {
          type: "image",
          en: "Banner EN_Junho_capright.gif",
          pt: "Banner PT_Junho_capright.gif",
          link: {
            en: "https://bit.ly/SiiLACaprightBR",
            pt: "https://bit.ly/SiiLACaprightBR"
          }
        },
        8: {
          type: "wistia",
          en: "07hkf5iq6j",
          pt: "xdcpgpw2hw",
          link: {
            en: "https://bit.ly/4cqAiAu",
            pt: "https://bit.ly/4kzhfpL"
          }
        }
      },

      mx: {
        1: {
          type: "wistia",
          en: "07hkf5iq6j",
          es: "cir4c9x01v",
          link: {
            en: "https://bit.ly/SiiLAMXEN",
            es: "https://bit.ly/SiiLAMXES"
          }
        },
        2: {
          type: "image",
          en: "caprigtEn.png",
          es: "caprigtEs.png",
          link: {
            en: "https://bit.ly/SiiLACaprightMX",
            es: "https://bit.ly/SiiLACaprightMX"
          }
        },
        3: {
          type: "image",
          en: "Avalous EN.gif",
          es: "Avalous ES.gif",
          link: {
            en: "https://bit.ly/SiiLIEIMX",
            es: "https://bit.ly/SiiLIEIMX"
          }
        },
        4: {
          type: "wistia",
          en: "07hkf5iq6j",
          es: "cir4c9x01v",
          link: {
            en: "https://bit.ly/SiiLAMXEN",
            es: "https://bit.ly/SiiLAMXES"
          }
        },
        5: {
          type: "image",
          en: "caprigtEn.png",
          es: "caprigtEs.png",
          link: {
            en: "https://bit.ly/SiiLACaprightMX",
            es: "https://bit.ly/SiiLACaprightMX"
          }
        },
        6: {
          type: "image",
          en: "Avalous EN.gif",
          es: "Avalous ES.gif",
          link: {
            en: "https://bit.ly/SiiLIEIMX",
            es: "https://bit.ly/SiiLIEIMX"
          }
        }
      },

      latam: {
        1: {
          type: "wistia",
          en: "07hkf5iq6j",
          es: "cir4c9x01v",
          link: this.ts.buildCrossCountryUrl("latam", "")
        },
        2: {
          type: "image",
          en: "caprigtEn.png",
          es: "caprigtEs.png",
          link: {
            en: "https://www.capright.com/",
            es: "https://www.capright.com/es/"
          }
        },
        3: {
          type: "wistia",
          en: "07hkf5iq6j",
          es: "cir4c9x01v",
          link: this.ts.buildCrossCountryUrl("latam", "")
        },
        4: {
          type: "image",
          en: "caprigtEn.png",
          es: "caprigtEs.png",
          link: {
            en: "https://www.capright.com/",
            es: "https://www.capright.com/es/"
          }
        },
        5: {
          type: "wistia",
          en: "07hkf5iq6j",
          es: "cir4c9x01v",
          link: this.ts.buildCrossCountryUrl("latam", "")
        },
        6: {
          type: "image",
          en: "caprigtEn.png",
          es: "caprigtEs.png",
          link: {
            en: "https://www.capright.com/",
            es: "https://www.capright.com/es/"
          }
        }
      }
    };

    const banner = (banners as any)[code]?.[rotation];
    const imgName = banner?.[lang] || "default.png";
    const rawLink = banner?.link;

    let resolvedLink = "";
    if (typeof rawLink === "string") {
      resolvedLink = rawLink;
    } else if (typeof rawLink === "object") {
      resolvedLink = rawLink?.[lang] || "";
    }

    const meta = this.advertiserMeta[code]?.[rotation];
    return {
      img: img + imgName,
      link: resolvedLink,
      type: banner?.type || "image",
      advertiserSlug: meta?.advertiserSlug,
      advertiserName: meta?.advertiserName
    };
  }

  private findTitleTranslation(titleKey: string, staticImg?: string) {
    const title = this.ts.getTranslationFromJSONFiles(
      `imgSEO.${titleKey}.title`
    );

    let result: ImageSEO = {
      src: staticImg,
      title: title,
      alt: title
    };
    return result;
  }

  private setBannerTitle(titleKey: string, staticImg?) {
    let result: ImageSEO = {
      src: staticImg.img,
      title: titleKey,
      alt: titleKey,
      link: staticImg.link,
      type: staticImg.type,
      wistiaId:
        staticImg.type === "wistia"
          ? staticImg.img.replace("../../../../assets/img/", "")
          : undefined,
      advertiserSlug: staticImg.advertiserSlug,
      advertiserName: staticImg.advertiserName
    };
    return result;
  }
}
